import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const financialLegalCompleteness: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.FINANCIAL_LEGAL_COMPLETENESS,
  label: "Financial and legal completeness",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "what's outstanding (tax filings, court-ordered payments)",
    "how long it's been outstanding",
    "what steps, if any, are being taken to resolve it",
  ],
  followUpTriggers: [
    "it's unclear how far behind the candidate actually is",
    "there's no plan or step described toward resolving it",
  ],
  hardBarrierFacts: [
    "a firearms licence revoked (not merely refused) for public-safety reasons",
  ],
  crossCuttingNotes: [
    "falling behind on tax filings or court-ordered payments (e.g. child support) is fixable if caught early — follow-up gathers the story, and only an unresolved case gets a standard flag",
    "firearms ownership itself is neutral and just recorded; only a refusal or revocation goes to a human",
  ],
};
